<script>
  import { colors } from './utils.js';

  export let col = 'medium';
  export let grid = '';
  export let caption = null;
  export let theme = null;

  let style = '';

  if (grid !== '') {
    grid = ` grid-${grid}`;
  }

  if (theme) {
    style += ` color: ${colors[theme]['text']}; background-color: ${colors[theme]['background']};`
  }
</script>

<figure style="{style}">
	<div class="col-{col}">
		<div class="grid{grid}">
			<slot></slot>
		</div>
  </div>
</figure>
{#if caption}
<caption style="{style}">
  <div class="col-medium">
    <div class="caption">{@html caption}</div>
  </div>
</caption>
{/if}